<form [formGroup]="valueItemForm" class="card mb-3">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col" translate>
        Constant interval
      </div>
      <div class="col-auto">
        <button type="button"
          class="btn btn-xs btn-outline-danger"
          (click)="onRemoveInterval()"
          [title]="'Delete interval' | translate">
          <span class="fa-solid fa-trash"></span>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="form-row" [ngClass]="{ 'is-invalid': valueItemForm.errors }">
      <!-- VALUE-->
      <div class="col-12">
        <div class="form-group">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="value" translate>Value</label>
            </div>
            <input name="value"
              (input)="onValueChange()"
              formControlName="value"
              id="value"
              type="text"
              class="form-control fix-rounded-right"
              [ngClass]="{ 'is-invalid': f.value.errors }">
              @if (f.value.errors) {
                <div class="invalid-feedback">
                  @if (f.value.errors.required) {
                    <span translate>Organization constant value required</span>
                  }
                  @if (f.value.errors.wrongType) {
                    <span>
                      <span translate>Invalid value. Not a valid:</span>
                      <span [innerText]="type"></span>
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        </div>

        <!-- START TIME-->
        <div class="col-12 col-lg-6">
          <div class="form-group mb-2 mb-lg-0">
            <label for="startTimestamp"><span translate>Start</span></label>
            <div class="input-group">
              <input class="form-control bg-white"
                formControlName="startTimestamp"
                (click)="start.toggle()"
                [readOnly]="true"
                [placeholder]="dateTimeFormat"
                id="startTimestamp"
                (closed)="onStartDateChange()"
                ngbDatepicker #start="ngbDatepicker"
                [ngClass]="{ 'is-invalid':  f.startTimestamp.errors }">
                <div class="input-group-append">
                  <button class="btn btn-outline-primary" (click)="start.toggle()" type="button">
                    <em class="fa-solid fa-calendar"></em>
                  </button>
                </div>
                @if (f.startTimestamp.errors) {
                  <div class="invalid-feedback">
                    @if (f.startTimestamp.errors.required) {
                      <span translate>Organization constant start date required</span>
                    }
                    @if (f.startTimestamp.errors.wrong) {
                      <span translate>Start date is after end date</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div class="form-group mb-0">
              <label for="endTimestamp"><span translate>End</span></label>
              <div class="input-group">
                <input class="form-control bg-white"
                  formControlName="endTimestamp"
                  (click)="end.toggle()"
                  [placeholder]="dateTimeFormat"
                  [readOnly]="true"
                  (closed)="onEndDateChange()"
                  id="endTimestamp"
                  ngbDatepicker #end="ngbDatepicker"
                  [ngClass]="{ 'is-invalid':  f.endTimestamp.errors }">
                  <div class="input-group-append">
                    <button class="btn btn-outline-primary" (click)="end.toggle()" type="button">
                      <em class="fa-solid fa-calendar"></em>
                    </button>
                  </div>

                  @if (f.endTimestamp.errors) {
                    <div class="invalid-feedback">
                      @if (f.endTimestamp.errors.required) {
                        <span translate>Organization constant end date required</span>
                      }
                      @if (f.endTimestamp.errors.wrong) {
                        <span translate>End date is before start date</span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>

          </div>

          @if (valueItemForm.errors) {
            <div class="form-row invalid-feedback">
              @if (valueItemForm.errors.overlapping) {
                <span
                translate>Invalid interval. overlapping with existing interval</span>
              }
            </div>
          }

        </div>
      </form>
